"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiTypography = getMuiTypography;
function getMuiTypography(palette) {
  return {
    defaultProps: {
      gutterBottom: false
    },
    styleOverrides: {
      gutterBottom: {
        '&.MuiTypography-h1': {
          marginBottom: '24px'
        },
        marginBottom: '16px'
      },
      h1: {
        fontSize: '24px',
        fontWeight: 600,
        lineHeight: '32px'
      },
      h2: {
        fontSize: '18px',
        fontWeight: 600,
        lineHeight: '24px'
      },
      h3: {
        fontSize: '16px',
        fontWeight: 600,
        lineHeight: '24px'
      },
      h5: {
        fontSize: '14px',
        fontWeight: 600,
        lineHeight: 'auto'
      },
      paragraph: {
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '24px'
      }
    },
    variants: [{
      props: {
        variant: 'error'
      },
      style: {
        color: palette.error.main,
        fontSize: '16px',
        fontWeight: 'bold',
        lineHeight: '24px'
      }
    }, {
      props: {
        variant: 'link'
      },
      style: {
        '&:hover': {
          textDecoration: 'underline'
        },
        color: palette.info.main,
        cursor: 'pointer',
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '24px'
      }
    }, {
      props: {
        variant: 'displayxlregular'
      },
      style: {
        fontSize: '5.143rem',
        fontWeight: 400,
        lineHeight: '7.143rem'
      }
    }, {
      props: {
        variant: 'displayxllight'
      },
      style: {
        fontSize: '5.143rem',
        fontWeight: 300,
        lineHeight: '7.143rem'
      }
    }, {
      props: {
        variant: 'displayxlsemibold'
      },
      style: {
        fontSize: '5.143rem',
        fontWeight: 600,
        lineHeight: '7.143rem'
      }
    }, {
      props: {
        variant: 'displaylgregular'
      },
      style: {
        fontSize: '4.571rem',
        fontWeight: 400,
        lineHeight: '6.357rem'
      }
    }, {
      props: {
        variant: 'displaylglight'
      },
      style: {
        fontSize: '4.571rem',
        fontWeight: 300,
        lineHeight: '6.357rem'
      }
    }, {
      props: {
        variant: 'displaylgsemibold'
      },
      style: {
        fontSize: '4.571rem',
        fontWeight: 600,
        lineHeight: '6.357rem'
      }
    }, {
      props: {
        variant: 'h1regular'
      },
      style: {
        fontSize: '2.286rem',
        fontWeight: 400,
        lineHeight: '3.143rem'
      }
    }, {
      props: {
        variant: 'h1light'
      },
      style: {
        fontSize: '2.286rem',
        fontWeight: 300,
        lineHeight: '3.143rem'
      }
    }, {
      props: {
        variant: 'h1semibold'
      },
      style: {
        fontSize: '2.286rem',
        fontWeight: 600,
        lineHeight: '3.143rem'
      }
    }, {
      props: {
        variant: 'h2regular'
      },
      style: {
        fontSize: '2rem',
        fontWeight: 400,
        lineHeight: '2.786rem'
      }
    }, {
      props: {
        variant: 'h2light'
      },
      style: {
        fontSize: '2rem',
        fontWeight: 300,
        lineHeight: '2.786rem'
      }
    }, {
      props: {
        variant: 'h2semibold'
      },
      style: {
        fontSize: '2rem',
        fontWeight: 600,
        lineHeight: '2.786rem'
      }
    }, {
      props: {
        variant: 'h3regular'
      },
      style: {
        fontSize: '1.714rem',
        fontWeight: 400,
        lineHeight: '2.357rem'
      }
    }, {
      props: {
        variant: 'h3semibold'
      },
      style: {
        fontSize: '1.714rem',
        fontWeight: 600,
        lineHeight: '2.357rem'
      }
    }, {
      props: {
        variant: 'h4regular'
      },
      style: {
        fontSize: '1.429rem',
        fontWeight: 400,
        lineHeight: '2rem'
      }
    }, {
      props: {
        variant: 'h4semibold'
      },
      style: {
        fontSize: '1.429rem',
        fontWeight: 600,
        lineHeight: '2rem'
      }
    }, {
      props: {
        variant: 'h5regular'
      },
      style: {
        fontSize: '1.286rem',
        fontWeight: 400,
        lineHeight: '1.857rem'
      }
    }, {
      props: {
        variant: 'h5semibold'
      },
      style: {
        fontSize: '1.286rem',
        fontWeight: 600,
        lineHeight: '1.857rem'
      }
    }, {
      props: {
        variant: 'bodycopyregular'
      },
      style: {
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '22px'
      }
    }, {
      props: {
        variant: 'bodycopysemibold'
      },
      style: {
        fontSize: '14px',
        fontWeight: 600,
        lineHeight: '22px'
      }
    }, {
      props: {
        variant: 'smalltextregular'
      },
      style: {
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '16px'
      }
    }, {
      props: {
        variant: 'smalltextsemibold'
      },
      style: {
        fontSize: '12px',
        fontWeight: 600,
        lineHeight: '16px'
      }
    }, {
      props: {
        variant: 'extrasmalltextregular'
      },
      style: {
        fontSize: '10px',
        fontWeight: 400,
        lineHeight: '14px'
      }
    }, {
      props: {
        variant: 'extrasmalltextsemibold'
      },
      style: {
        fontSize: '10px',
        fontWeight: 600,
        lineHeight: '14px'
      }
    }, {
      props: {
        variant: 'xxsmalltextregular'
      },
      style: {
        fontSize: '8px',
        fontWeight: 400,
        lineHeight: '14px'
      }
    }, {
      props: {
        variant: 'xxsmalltextsemibold'
      },
      style: {
        fontSize: '8px',
        fontWeight: 600,
        lineHeight: '14px'
      }
    }]
  };
}